const IMPERIAL_FORECAST = [
  'weather_forecast/wind/mph',
  'weather_forecast/temperature/fahrenheit',
  'weather_forecast/precipitation',
];
const METRIC_FORECAST = [
  'weather_forecast/wind/kph',
  'weather_forecast/temperature/celsius',
  'weather_forecast/precipitation',
];

export default {
  IMPERIAL_FORECAST,
  METRIC_FORECAST,
};
